import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [token, setToken] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await api.post("/admin/login", { token });
            localStorage.setItem("ss_admin_token", res.data.token);
            toast.success("Welcome back.");
            navigate("/admin/dashboard");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Invalid access code");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen bg-navy-deep text-cream flex items-center justify-center px-6 relative overflow-hidden">
            <div className="absolute inset-0 bg-grain opacity-40 pointer-events-none" />
            <form onSubmit={submit} className="relative w-full max-w-md border border-gold/40 bg-navy p-10">
                <div className="flex items-center gap-3 mb-8">
                    <div className="w-12 h-12 rounded-full border border-gold flex items-center justify-center">
                        <Sparkles className="w-6 h-6 text-gold" />
                    </div>
                    <div className="flex flex-col leading-none">
                        <span className="font-script text-3xl text-gold -mb-1">Signature</span>
                        <span className="font-playfair text-xs tracking-[0.3em] uppercase">Admin Portal</span>
                    </div>
                </div>
                <h1 className="font-playfair text-2xl mb-2">Staff Access</h1>
                <p className="text-cream/70 font-outfit text-sm mb-8">Enter your administrator passcode to view bookings.</p>
                <label className="uppercase tracking-[0.2em] text-xs font-bold text-gold mb-3 block">Access Code</label>
                <input
                    data-testid="admin-token-input"
                    type="password"
                    value={token}
                    onChange={(e) => setToken(e.target.value)}
                    className="w-full bg-navy-deep border border-cream/20 px-4 py-3 font-outfit text-cream focus:outline-none focus:border-gold"
                    placeholder="••••••••••••"
                />
                <button
                    data-testid="admin-login-btn"
                    type="submit"
                    disabled={loading}
                    className="w-full mt-6 bg-gold text-navy py-3 font-outfit font-semibold tracking-wide uppercase text-sm inline-flex items-center justify-center gap-3 hover:bg-gold-light transition-colors disabled:opacity-50"
                >
                    {loading ? "Signing in…" : "Enter Dashboard"} <ArrowRight className="w-4 h-4" />
                </button>
                <p className="text-xs text-cream/40 mt-6 text-center italic">Default code: <code>signature-shine-admin-2026</code></p>
            </form>
        </div>
    );
}
